function createList(items) {
  return `
    <hr style="opacity: 0.2" />
    <ul class="helper-popover__list">
      ${items
      .map(
        item => `
      <li class="helper-popover__list-item">
        <span class="helper-popover__list-item__label">${item.title}</span>
        <span class="helper-popover__list-item__sublabel">${item.subtitle}</span>
      </li>
    `,
      )
      .join('')}
    </ul>
  `
}

export default ctx => {
  return [
    {
      id: 'footer-content.json',
      title: ctx.$t('footer'),
      body: ctx.$t('projectAdditionalFieldsDescriptionFooter'),
      image: require('@/assets/custom-fields/footer-content.png'),
      link: ctx.$store.getters.helpcenterUrl('5203634'),
    },
    {
      id: 'subpages.json',
      title: ctx.$tc('subpage', 2),
      body: ctx.$t('projectAdditionalFieldsDescriptionSubpage'),
      image: require('@/assets/custom-fields/subpages.png'),
      link: ctx.$store.getters.helpcenterUrl('5203585'),
    },
    {
      id: 'residential-templates.json',
      title: ctx.$t('customFieldsUnitCatalogLabel'),
      body: ctx.$t('projectAdditionalFieldsDescriptionResidentailTemplate'),
      image: require('@/assets/custom-fields/residential-template.png'),
      link: ctx.$store.getters.helpcenterUrl('5203562'),
    },
    {
      id: 'additional-info.json',
      title: ctx.$t('nearbyarea'),
      body: ctx.$t('projectAdditionalFieldsDescriptionArea'),
      image: require('@/assets/custom-fields/additional-info.png'),
      link: ctx.$store.getters.helpcenterUrl('5203625'),
    },
    {
      id: 'social-media.json',
      title: ctx.$t('socialMedia'),
      body: ctx.$t('projectAdditionalFieldsSoMeDescriptionArea'),
      image: require('@/assets/custom-fields/social-media.png'),
    },

    {
      id: 'facebook-ads.json',
      title: ctx.$t('facebookAds'),
      body: ctx.$t('projectAdditionalFieldsFacebookAdsDescriptionArea'),
    },
    {
      id: 'privacy-policy.json',
      title: ctx.$t('privacyPolicyTitle'),
      body: ctx.$t('customPrivacySublabel'),
    },
    {
      id: 'salesman-page-helper',
      body: ctx.$t('salesmanPageVisibility'),
    },
    {
      id: 'salesman-helper',
      body: ctx.$t('salesmanVisibility'),
    },
    {
      id: 'salesman-shop-helper',
      body: ctx.$t('salesmanShopVisibility'),
    },
    {
      id: 'product-bundle',
      body: ctx.$t('helpers:productBundle'),
    },
    {
      id: 'product-options',
      body: ctx.$t('helpers:productOptions'),
    },
    {
      id: 'management-operation-maintenance-helper',
      body: ctx.$t('helpers:managementOperationMaintenance'),
    },

    {
      id: 'management-operation-maintenance-confirm',
      body: ctx.$t('documentUploadConfirm'),
    },
    {
      id: 'residential-properties-create',
      body: ctx.$t('helpers:residentialPropertiesCreate'),
    },

    {
      id: 'complaints-list',
      body: ctx.$t('helpers:complaintsList'),
    },
    {
      id: 'project:purchase',
      title: ctx.$t('includedInAddon'),
      body: createList([
        {
          title: ctx.$t('addon:project:purchase:digital:title'),
          subtitle: ctx.$t('addon:project:purchase:digital:subtitle'),
        },
        {
          title: ctx.$t('addon:project:archive:title'),
          subtitle: ctx.$t('addon:project:archive:subtitle'),
        },
        { title: ctx.$t('addon:project:sign:title'), subtitle: ctx.$t('addon:project:sign:subtitle') },
        {
          title: ctx.$t('addon:project:residential-account'),
          subtitle: ctx.$t('addon:project:residential-account:sublabel'),
        },
      ]),
    },
    {
      id: 'project:bid',
      title: ctx.$t('includedInAddon'),
      body: createList([
        {
          title: ctx.$t('addon:project:purchase:digital:title'),
          subtitle: ctx.$t('addon:project:purchase:digital:subtitle'),
        },
        {
          title: ctx.$t('addon:project:archive:title'),
          subtitle: ctx.$t('addon:project:archive:subtitle'),
        },
        { title: ctx.$t('addon:project:sign:title'), subtitle: ctx.$t('addon:project:sign:subtitle') },
        {
          title: ctx.$t('addon:project:residential-account'),
          subtitle: ctx.$t('addon:project:residential-account:sublabel'),
        },
      ]),
    },
    {
      id: 'project:shop',
      title: ctx.$t('includedInAddon'),
      body: createList([
        { title: ctx.$t('project:shop:presentation:title'), subtitle: ctx.$t('project:shop:presentation:subtitle') },
        {
          title: ctx.$t('addon:project:residential-account'),
          subtitle: ctx.$t('addon:project:residential-account:sublabel'),
        },
      ]),
    },
    {
      id: 'project:shop-purchase',
      title: ctx.$t('includedInAddon'),
      body: createList([
        { title: ctx.$t('project:shop:presentation:title'), subtitle: ctx.$t('project:shop:presentation:subtitle') },
        {
          title: ctx.$t('project:shop-purchase:digital:title'),
          subtitle: ctx.$t('project:shop-purchase:digital:subtitle'),
        },
        {
          title: ctx.$t('addon:project:archive:title'),
          subtitle: ctx.$t('addon:project:archive:subtitle'),
        },
        { title: ctx.$t('addon:project:sign:title'), subtitle: ctx.$t('addon:project:sign:subtitle') },
        {
          title: ctx.$t('addon:project:residential-account'),
          subtitle: ctx.$t('addon:project:residential-account:sublabel'),
        },
      ]),
    },
    {
      id: 'project:presentation',
      title: ctx.$t('includedInAddon'),
      body: createList([
        {
          title: ctx.$t('addon:project:upcoming-presentation'),
          subtitle: ctx.$t('addon:project:upcoming-presentation:sublabel'),
        },
        {
          title: ctx.$t('addon:project:presentation'),
          subtitle: ctx.$t('addon:project:upcoming-presentation:sublabel'),
        },
        {
          title: ctx.$t('addon:project:presentation'),
          subtitle: ctx.$t('addon:project:presentation:subtitle'),
        },
        {
          title: ctx.$t('addon:project:presentation:theme:color'),
          subtitle: ctx.$t('addon:project:presentation:theme:color:subtitle'),
        },
        {
          title: ctx.$t('addon:project:flatfinder'),
          subtitle: ctx.$t('addon:project:flatfinder:subtitle'),
        },
        {
          title: ctx.$t('addon:project:analytics:title'),
          subtitle: ctx.$t('addon:project:analytics:subtitle'),
        },
      ]),
    },
    {
      id: 'project:upcoming-presentation',
      title: ctx.$t('includedInAddon'),
      body: createList([
        {
          title: ctx.$t('addon:project:upcoming-presentation'),
          subtitle: ctx.$t('addon:project:upcoming-presentation:sublabel'),
        },
        {
          title: ctx.$t('addon:project:presentation'),
          subtitle: ctx.$t('addon:project:presentation:subtitle'),
        },
        {
          title: ctx.$t('addon:project:presentation:theme:color'),
          subtitle: ctx.$t('addon:project:presentation:theme:color:subtitle'),
        },
        {
          title: ctx.$t('addon:project:analytics:title'),
          subtitle: ctx.$t('addon:project:analytics:subtitle'),
        },
      ]),
    },
    {
      id: 'project:residential-account',
      title: ctx.$t('includedInAddon'),
      body: createList([
        {
          title: ctx.$t('project:residential-account:presentation'),
          subtitle: ctx.$t('project:residential-account:presentation:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:contract:title'),
          subtitle: ctx.$t('project:residential-account:contract:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:dialog:title'),
          subtitle: ctx.$t('project:residential-account:dialog:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:fdv:title'),
          subtitle: ctx.$t('project:residential-account:fdv:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:sale:title'),
          subtitle: ctx.$t('project:residential-account:sale:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:contract:share:title'),
          subtitle: ctx.$t('project:residential-account:contract:share:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:fdv:documentation:title'),
          subtitle: ctx.$t('project:residential-account:fdv:documentation:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:contract:residential:title'),
          subtitle: ctx.$t('project:residential-account:contract:residential:subtitle'),
        },
        {
          title: ctx.$t('project:residential-account:contract:complaint:title'),
          subtitle: ctx.$t('helpers:complaintsList'),
        },
      ]),
    },
    {
      id: 'complaint-members-helper',
      title: ctx.$t('complaintMembersHelper'),
    },
    {
      id: 'complaint-created-by-helper',
      title: ctx.$t('complaintCreatedByHelper'),
    },
    {
      id: 'user-level-helper',
      title: ctx.$t('whatIs', { x: ctx.$t('userLevel').toLowerCase() }),
      body: ctx.$t('helper:userLevel'),
    },
    {
      id: 'residentials-settings-property-helper',
      body: ctx.$t('residentialsSettingsPropertyHelper'),
    },
    {
      id: 'residentials-settings-facility-helper',
      body: ctx.$t('residentialsSettingsFacilityHelper'),
    },

    {
      id: 'devtools-helper',
      title: ctx.$t('whatIs', { x: ctx.$t('devtools').toLowerCase() }),
      body: ctx.$t('helper:devtools'),
    },
    {
      id: 'access-helper',
      title: ctx.$t('whatMeans', { x: ctx.$tc('access', 2).toLowerCase() }),
      body: ctx.$t('helper:access'),
    },
    {
      id: 'roles-helper',
      title: ctx.$t('whatIs', { x: ctx.$tc('role', 2).toLowerCase() }),
      body: ctx.$t('helper:roles'),
      link: ctx.$store.getters.helpcenterUrl('14417'),
    },
    {
      id: 'domain-helper',
      body: ctx.$t('domainHelper', { link: `<a href='${ctx.$store.state.domain}' target="_blank">${ctx.$store.state.domain}</a>` }),
    },
  ]
}
